"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Play = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  circleSize,
  isInteractive,
  theme
}) => ({
  backgroundColor: theme.palette.blueGrey[300],
  borderRadius: '50%',
  cursor: 'pointer',
  display: 'flex',
  height: circleSize,
  position: 'relative',
  transition: theme.transitions.create(['background-color', 'width', 'height'], {
    duration: theme.transitions.duration.standard
  }),
  width: circleSize,
  '&:hover': {
    background: isInteractive ? theme.palette.common.black : theme.palette.blueGrey[300]
  }
}));
const Play = exports.Play = (0, _mui.styled)(_icons.PlayFilled, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['playSize'])
})(({
  playSize,
  theme
}) => ({
  bottom: 0,
  fill: theme.palette.common.white,
  height: playSize,
  left: 0,
  margin: 'auto',
  position: 'absolute',
  right: 0,
  top: 0,
  transition: 'width 300ms, height 300ms',
  width: playSize
}));
//# sourceMappingURL=styles.js.map